import * as configs from "./configs";
// export * as forms from "./forms";

export const form = {
    ...configs
}